export const PROPERTIES_STATE = 'properties'

export const FETCH_PROPERTIES_REQUEST = 'FETCH_PROPERTIES_REQUEST'
export const FETCH_PROPERTIES_SUCCESS = 'FETCH_PROPERTIES_SUCCESS'
export const FETCH_PROPERTIES_FAILURE = 'FETCH_PROPERTIES_FAILURE'
